import { setStoreValue } from "@/store/utils";

export const SET_IS_FETCHING_USER_EXPERIENCE =
  "SET_IS_FETCHING_USER_EXPERIENCE";
export const SET_CURRENT_USER_EXPERIENCE = "SET_CURRENT_USER_EXPERIENCE";
export const SET_EXPERIENCE_FUNCTIONS = "SET_EXPERIENCE_FUNCTIONS";
export const SET_REASONS_FOR_LEAVING = "SET_REASONS_FOR_LEAVING";
export const SET_IS_FETCHING_REASONS_FOR_LEAVING =
  "SET_IS_FETCHING_REASONS_FOR_LEAVING";
export const SET_IS_FETCHING_EXPERIENCE_FUNCTIONS =
  "SET_IS_FETCHING_EXPERIENCE_FUNCTIONS";

const mutations = {
  [SET_IS_FETCHING_USER_EXPERIENCE]: setStoreValue("isFetchingUserExperience"),
  [SET_CURRENT_USER_EXPERIENCE]: setStoreValue("currentUserExperience"),
  [SET_REASONS_FOR_LEAVING]: setStoreValue("reasonsForLeaving"),
  [SET_IS_FETCHING_REASONS_FOR_LEAVING]: setStoreValue(
    "isFetchingReasonsForLeaving"
  ),
  [SET_EXPERIENCE_FUNCTIONS]: setStoreValue("experienceFunctions"),
  [SET_IS_FETCHING_EXPERIENCE_FUNCTIONS]: setStoreValue(
    "isFetchingExperienceFunctions"
  )
};

const state = {
  currentUserExperience: [],
  isFetchingUserExperience: false,
  experienceFunctions: [],
  isFetchingExperienceFunctions: false,
  isFetchingReasonsForLeaving: false,
  reasonsForLeaving: []
};

export { mutations, state };
